import styled from '@emotion/styled';
import { Tabs } from 'antd';
import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import Banner from './components/Banner';
import DriverPortalLayout from './components/DriverPortalLayout';
import LoginForm from './LoginPage';
import SignUpForm from './SignupPage';

const { TabPane } = Tabs;

const TabStyled = styled(Tabs)`
  .ant-tabs-nav-wrap {
    display: flex;
    justify-content: center;
    align-content: center;
  }
`;

export interface IDriverPortal {}

const DriverPortal: React.FC<IDriverPortal> = props => {
  const [activeTab, setActiveTap] = useState<string>('');
  const history = useHistory();

  useEffect(() => {
    const pathName = history.location.pathname;
    const setDefaultTab = (pathName: string) => {
      switch (pathName) {
        case '/signup':
          setActiveTap('signup');
          break;
        case '/login':
          setActiveTap('login');
          break;
        default:
          break;
      }
    };
    setDefaultTab(pathName);
  }, [history]);

  const handleChange = (key: string) => {
    history.replace(`/${key}${history?.location?.search}`);
  };

  return (
    <DriverPortalLayout>
      <Banner />
      <TabStyled
        activeKey={activeTab}
        defaultActiveKey={activeTab}
        onChange={handleChange}
      >
        <TabPane tab="สมัครสมาชิก" key="signup">
          <SignUpForm />
        </TabPane>
        <TabPane tab="เข้าสู่ระบบ" key="login">
          <LoginForm />
        </TabPane>
      </TabStyled>
    </DriverPortalLayout>
  );
};

export default DriverPortal;
